import React from "react"

import WindowCard from "../../../../components/ui/window-card/window-card"

import { TEE_SHEET_CONFIG } from "./config"
import { countAnsweredQuestions, getEnabledSectionIds, mergeTeeSheetSnapshot } from "./model"

const sectionsExceptStatements = TEE_SHEET_CONFIG.sections.filter((section) => section.id !== "statements")
const statementsSection = TEE_SHEET_CONFIG.sections.find((section) => section.id === "statements")

const blocks = [
	...sectionsExceptStatements.map((section, index) => ({
		id: section.id,
		label: section.title,
		number: index + 1,
	})),
	{
		id: "additional_notes",
		label: "Additional notes",
		number: sectionsExceptStatements.length + 1,
	},
	...(statementsSection
		? [
				{
					id: statementsSection.id,
					label: statementsSection.title,
					number: sectionsExceptStatements.length + 2,
				},
		  ]
		: []),
]

const hasAnswer = (question) => {
	const value = question?.answer
	if (Array.isArray(value)) return value.length > 0
	return value !== null && value !== undefined && value !== ""
}

const getBlockStatus = (snapshot, block) => {
	if (block.id === "additional_notes") {
		return snapshot.additional_notes ? "Added" : "Optional"
	}

	const section = (snapshot.sections || []).find((s) => s.id === block.id)
	if (!section) return "Missing"

	const enabledSectionIds = new Set(getEnabledSectionIds(snapshot))
	if (!enabledSectionIds.has(section.id)) return "Off"

	const questions = (section.questions || []).filter((question) => !question.historical)
	const unanswered = questions.filter((question) => !hasAnswer(question)).length
	return unanswered === 0 ? "Complete" : `${unanswered} missing`
}

function TeeSheetJumpNav({ teeSheet }) {
	const snapshot = mergeTeeSheetSnapshot(teeSheet, TEE_SHEET_CONFIG)
	const progress = countAnsweredQuestions(snapshot)

	const jumpToBlock = (blockId) => {
		const element = document.getElementById(`tee-sheet-block-${blockId}`)
		if (!element) return
		element.scrollIntoView({ behavior: "smooth", block: "start" })
	}

	return (
		<WindowCard
			className="tee-sheet-jump-card"
			title={
				<span className="tee-sheet-jump-title">
					<span>Tee Sheet blocks</span>
					<small className="tee-sheet-jump-progress">{progress.answered}/{progress.total} answered</small>
				</span>
			}>
			<div className="tee-sheet-jump-list">
				{blocks.map((block) => {
					const status = getBlockStatus(snapshot, block)
					return (
						<button
							key={block.id}
							type="button"
							className={`is-${status.toLowerCase().replace(/\s+/g, "-")}`}
							onClick={() => jumpToBlock(block.id)}>
							<span>{block.number}.</span>
							<strong>{block.label}</strong>
							<small>{status}</small>
						</button>
					)
				})}
			</div>
		</WindowCard>
	)
}

export default TeeSheetJumpNav
